function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-54bdb1ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=tqk19250jg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./SolutionsContent.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=tqk19250jg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./SolutionsContent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-54bdb1ce\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=tqk19250jg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./SolutionsContent.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54bdb1ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/hub/SolutionsContent.vue
// module id = 615
// module chunks = 0